import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Typography,
  message,
} from "antd";
// import { tutorSubject } from "../../../../actions/tutorwithsubject";
import { setTeacherSubjects } from "../../../../reducers/subjectTutor";
import {
  retriveToken,
  deleteToken,
  fetchSubjectTeacher,
  updateProfile,
} from "../../../../services/AuthServices";
import moment from "moment";
import { givenLevels, givenSchools } from "../../../common/constants";
import DiamondIcon from "../../../../assets/diamond.svg";
import "../profile.css";
import Alert from "../../../common/alert";

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  // console.log(auth);

  const teacherSubjects = useSelector((state) => state.teacherSubjects);

  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const initialValues = {
    name: auth?.user?.name || "",
    level: auth?.user?.level || undefined,
    goalForMath: auth?.user?.goalForMath || 0,
    goalForEnglish: auth?.user?.goalForEnglish || 0,
    goalForScience: auth?.user?.goalForScience || 0,
    school: auth?.user?.school || "",
    countDownTimer:
      auth?.user?.countDownTimer && auth?.user?.countDownTimer !== ""
        ? moment.utc(auth?.user?.countDownTimer, "YYYY-MM-DD").local()
        : null,
    notesOnCountDown: auth?.user?.notesOnCountDown || "",
    email: auth?.user?.emailid || "",
    postalCode: auth?.user?.postalCode || "",
    engTutors: auth?.user?.engTutor?.value || undefined,
    mathTutors: auth?.user?.mathTutor?.value || undefined,
    sciTutors: auth?.user?.sciTutor?.value || undefined,
    password: "",
    reEnterPassword: "",
  };

  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    fetchSubjectTeacher()
      .then((response) => {
        dispatch(setTeacherSubjects(response.data));
      })
      .catch((error) => {
        Alert("error", "Error!", "Failed to fetch subject teachers");
      });
  }, [dispatch]);

  const handleOpen = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleChangeUser = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    form.setFieldsValue({ [name]: value });
  };

  const handleLogOut = () => {
    deleteToken();
    navigate("/", { replace: true });
    window.location.reload();
  };

  const onChangeDate = (date, dateString) => {
    const utcDate = date ? moment.utc(dateString, "YYYY-MM-DD") : null;
    setValues((prev) => ({
      ...prev,
      countDownTimer: utcDate,
    }));
    form.setFieldsValue({ countDownTimer: utcDate });
  };

  const validateGoal = (_, value) => {
    if (value > 100) {
      return Promise.reject(new Error("Value should not be greater than 100"));
    }
    return Promise.resolve();
  };

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const token = retriveToken();
      if (!token || token === "undefined") {
        navigate("/");
        return;
      }

      if (values.password !== values.reEnterPassword) {
        Alert(
          "error",
          "Error!",
          "Password and re-enter password should be the same"
        );
        setIsModalOpen(false);
        return;
      }

      const response = await updateProfile(values);
      Alert("success", "Success!", response.data.message);

      setIsModalOpen(false);
    } catch (error) {
      Alert(
        "error",
        "Error!",
        error.response?.data?.message || "Failed to update profile"
      );

      setIsModalOpen(false);
    }
  };

  const handleLevelDifficultyChange = (name, value) => {
    const newValue = typeof value === "object" ? value.value : value;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    form.setFieldsValue({ [name]: newValue });
  };

  return (
    <div className="profile_wrapper">
      <div className="profile_containers">
        <div className="container">
          <div className="container_inner">
            <div className="edit_profile_container">
              <div className="space-between">
                <Typography className="profile_text">
                  EDIT MY PROFILE
                </Typography>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div className="rewardBox">
                    <img width="20px" src={DiamondIcon} alt="Points" />
                    <Typography style={{ color: "white" }}>
                      {auth?.user?.points?.toLocaleString() || 0}
                    </Typography>
                  </div>
                  <Button type="primary" onClick={handleLogOut}>
                    Log out
                  </Button>
                </div>
              </div>
              <Divider className="divier_edit" />
            </div>
            <Form
              form={form}
              layout="vertical"
              initialValues={initialValues}
              onFinish={handleOpen}
              requiredMark={false}
            >
              <Row>
                <Col span={24}>
                  <Typography className="detailsText_editProfile">
                    Child’s details
                  </Typography>
                </Col>
                <Col span={20} xs={24} md={18}>
                  <Row gutter={36} align={"middle"}>
                    <Col span={12} md={12} xs={24}>
                      <Form.Item
                        name="name"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            Name
                          </span>
                        }
                        rules={[
                          { required: true, message: "Please enter name" },
                        ]}
                      >
                        <Input
                          name="name"
                          value={values.name}
                          onChange={handleChangeUser}
                          className="input_editProfile"
                          aria-label="Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} md={12} xs={24}>
                      <Form.Item
                        name="level"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            Level of Study
                          </span>
                        }
                        rules={[
                          { required: true, message: "Please select a level" },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Select Level"
                          className="select_editProfile"
                          optionFilterProp="label"
                          options={givenLevels.map((d) => ({
                            value: d.value,
                            label: d.label,
                          }))}
                          onChange={(value) =>
                            handleLevelDifficultyChange("level", value)
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={36} justify="center" align="middle">
                    <Col span={12} md={12} xs={24}>
                      <Row gutter={16} justify="center" align="middle">
                        <Col span={12} md={12} xs={24}>
                          <Form.Item
                            name="goalForMath"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                }}
                              >
                                Goal For Math
                              </span>
                            }
                            rules={[
                              { validator: validateGoal },
                              {
                                required: true,
                                message: "Please enter Math goal",
                              },
                            ]}
                          >
                            <Input
                              name="goalForMath"
                              value={values.goalForMath}
                              onChange={handleChangeUser}
                              type="number"
                              min={0}
                              max={100}
                              className="input_editProfile"
                              aria-label="Goal for Math"
                              suffix="%"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} md={12} xs={24}>
                          <Form.Item
                            name="goalForEnglish"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                }}
                              >
                                Goal For English
                              </span>
                            }
                            rules={[
                              { validator: validateGoal },
                              {
                                required: true,
                                message: "Please enter English goal",
                              },
                            ]}
                          >
                            <Input
                              name="goalForEnglish"
                              value={values.goalForEnglish}
                              onChange={handleChangeUser}
                              type="number"
                              min={0}
                              max={100}
                              className="input_editProfile"
                              aria-label="Goal for English"
                              suffix="%"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12} md={12} xs={24}>
                      <Row gutter={16} justify="center" align="middle">
                        <Col span={10} md={12} xs={24}>
                          <Form.Item
                            name="goalForScience"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                }}
                              >
                                Goal For Science
                              </span>
                            }
                            rules={[
                              { validator: validateGoal },
                              {
                                required: true,
                                message: "Please enter Science goal",
                              },
                            ]}
                          >
                            <Input
                              name="goalForScience"
                              value={values.goalForScience}
                              onChange={handleChangeUser}
                              type="number"
                              min={0}
                              max={100}
                              className="input_editProfile"
                              aria-label="Goal for Science"
                              suffix="%"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={14} md={12} xs={24}>
                          <Form.Item
                            name="goalForMotherTongue"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Goal For Mother Tongue
                              </span>
                            }
                          >
                            <Input
                              disabled
                              className="input_editProfile"
                              aria-label="Goal for Mother Tongue"
                              suffix="%"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {/* <Row gutter={36} >
                    <Col span={12} md={12} xs={24}>
                      <Form.Item
                        name="school"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            School
                          </span>
                        }
                        rules={[
                          { required: true, message: "Please enter school" },
                        ]}
                      >
                        <Input
                          name="school"
                          value={values.school}
                          onChange={handleChangeUser}
                          className="input_editProfile"
                          aria-label="School"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} xs={24}>
                      <Row gutter={16}>
                        <Col md={12} xs={24}>
                          <Form.Item
                            name="countDownTimer"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                }}
                              >
                                CountDown Timer
                              </span>
                            }
                          >
                            <DatePicker
                              style={{ width: "100%" }}
                              disabledDate={(current) =>
                                current && current < moment().startOf("day")
                              }
                              className="inputTime"
                              value={values.countDownTimer}
                              onChange={onChangeDate}
                            />
                          </Form.Item>
                        </Col>
                        <Col md={12} xs={24}>
                          <Form.Item
                            name="notesOnCountDown"
                            label={
                              <span
                                style={{
                                  color: "white",
                                  fontWeight: 400,
                                  fontSize: 14,
                                }}
                              >
                                Notes On CountDown
                              </span>
                            }
                          >
                            <Input
                              name="notesOnCountDown"
                              value={values.notesOnCountDown}
                              onChange={handleChangeUser}
                              className="input_editProfile"
                              aria-label="Notes on countdown"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}

                  <Typography
                    style={{ fontSize: "18px" }}
                    className="detailsText_editProfile"
                  >
                    Select your tutor
                  </Typography>
                  <Row gutter={16}>
                    <Col span={12} md={8} xs={24}>
                      <Form.Item
                        name="mathTutors"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            Mathematics Tutor
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please select Mathematics tutor",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Math tutor name"
                          className="select_editProfile"
                          optionFilterProp="label"
                          options={teacherSubjects?.teacherSubjects?.data?.mathTutors?.map(
                            (d) => ({
                              value: d.value,
                              label: d.label,
                            })
                          )}
                          onChange={(value) =>
                            handleLevelDifficultyChange("mathTutors", {
                              value,
                              _id: teacherSubjects?.teacherSubjects?.data?.mathTutors?.find(
                                (t) => t.value === value
                              )?._id,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} md={8} xs={24}>
                      <Form.Item
                        name="sciTutors"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            Science Tutor
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please select Science tutor",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Sci tutor name"
                          className="select_editProfile"
                          optionFilterProp="label"
                          options={teacherSubjects?.teacherSubjects?.data?.sciTutors?.map(
                            (d) => ({
                              value: d.value,
                              label: d.label,
                            })
                          )}
                          onChange={(value) =>
                            handleLevelDifficultyChange("sciTutors", {
                              value,
                              _id: teacherSubjects?.teacherSubjects?.data?.sciTutors?.find(
                                (t) => t.value === value
                              )?._id,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} md={8} xs={24}>
                      <Form.Item
                        name="engTutors"
                        label={
                          <span
                            style={{
                              color: "white",
                              fontWeight: 400,
                              fontSize: 14,
                            }}
                          >
                            English Tutor
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please select English tutor",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Eng tutor name"
                          className="select_editProfile"
                          optionFilterProp="label"
                          options={teacherSubjects?.teacherSubjects?.data?.engTutors?.map(
                            (d) => ({
                              value: d.value,
                              label: d.label,
                            })
                          )}
                          onChange={(value) =>
                            handleLevelDifficultyChange("engTutors", {
                              value,
                              _id: teacherSubjects?.teacherSubjects?.data?.engTutors?.find(
                                (t) => t.value === value
                              )?._id,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Divider />

              <div className="container_inner">
                <Row>
                  <Col span={24}>
                    <Typography className="detailsText_editProfile">
                      Your Details
                    </Typography>
                  </Col>
                  <Col span={18} xs={24} md={18}>
                    <Row gutter={36}>
                      <Col span={12} md={12} xs={24}>
                        <Form.Item
                          name="email"
                          label={
                            <span
                              style={{
                                color: "white",
                                fontWeight: 400,
                                fontSize: 14,
                              }}
                            >
                              Email address
                            </span>
                          }
                        >
                          <Input
                            disabled
                            name="email"
                            value={values.email}
                            className="input_editProfile"
                            aria-label="Email address"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24}>
                        <Form.Item
                          name="postalCode"
                          label={
                            <span
                              style={{
                                color: "white",
                                fontWeight: 400,
                                fontSize: 14,
                              }}
                            >
                              Postal Code
                            </span>
                          }
                        >
                          <Input
                            disabled
                            name="postalCode"
                            value={values.postalCode}
                            className="input_editProfile"
                            aria-label="Postal Code"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={36}>
                      <Col span={12} md={12} xs={24}>
                        <Form.Item
                          name="password"
                          label={
                            <span
                              style={{
                                color: "white",
                                fontWeight: 400,
                                fontSize: 14,
                              }}
                            >
                              Passowrd
                            </span>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please enter password",
                            },
                          ]}
                        >
                          <Input.Password
                            name="password"
                            value={values.password}
                            onChange={handleChangeUser}
                            className="input_editProfile"
                            aria-label="Password"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12} md={12} xs={24}>
                        <Form.Item
                          name="reEnterPassword"
                          label={
                            <span
                              style={{
                                color: "white",
                                fontWeight: 400,
                                fontSize: 14,
                              }}
                            >
                              Re-enter your password
                            </span>
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please re-enter password",
                            },
                          ]}
                        >
                          <Input.Password
                            name="reEnterPassword"
                            value={values.reEnterPassword}
                            onChange={handleChangeUser}
                            className="input_editProfile"
                            aria-label="Re-enter password"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col
                    span={24}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "14px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        className="EditProfileCancelButton"
                        onClick={() => form.resetFields()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="EditProfileSaveButton"
                        type="primary"
                        htmlType="submit"
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        closable={false}
        centered
        onCancel={handleCancel}
        width={350}
        styles={{ borderRadius: "25px", zIndex: 999999 }}
      >
        <p className="modalTitle">
          Are you sure you want to save the profile data?
        </p>
        <div className="modalButtons">
          <Button className="modalButtonNo" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="modalButtonNo" onClick={handleSubmit}>
            Yes
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Profile;
